module.exports = __webpack_public_path__ + "static/media/cod.027bcf44.svg";